import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import { BusinessProfile } from "Types/Brand";

export const businessProfilesAdapter = createEntityAdapter<BusinessProfile>();

const BusinessProfileStateSlice = createSlice({
    name: "BusinessProfile",
    initialState: businessProfilesAdapter.getInitialState(),
    reducers: {
        setBusinessProfiles: businessProfilesAdapter.setAll,
    },
});

export const { setBusinessProfiles } = BusinessProfileStateSlice.actions;
export default BusinessProfileStateSlice.reducer;
